import { Box, Grid, Typography } from "@mui/material";
import { green, red, orange } from "@mui/material/colors";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import ReportProblemTwoToneIcon from "@mui/icons-material/ReportProblemTwoTone";
import CheckCircleTwoToneIcon from "@mui/icons-material/CheckCircleTwoTone";
import ErrorTwoToneIcon from "@mui/icons-material/ErrorTwoTone";

const LegaliLimitComponent = ({
    legalLimit,
    omsLimit,
    xs = 12,
    sm = 4,
    title,
    status,
    label,
    subLabel,
    isFem = false,
    isCO2 = false,
}) => {
    const { t } = useTranslation();

    return (
        <Grid
            item
            container
            xs={xs}
            sm={sm}
            alignItems="flex-start"
            justifyContent="center"
            sx={{ minHeight: 80 }}
        >
            {isCO2 ? (
                <Fragment>
                    <Grid
                        item
                        xs={12}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Typography variant="h6" color="white" align="center">
                            {title}
                        </Typography>

                        {legalLimit !== undefined && legalLimit !== null && (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                {legalLimit === 2 ? (
                                    <ErrorTwoToneIcon
                                        style={{
                                            color: red[500],
                                            width: 18,
                                            height: 18,
                                            marginLeft: 5,
                                        }}
                                    />
                                ) : legalLimit === 1 ? (
                                    <ReportProblemTwoToneIcon
                                        style={{
                                            color: orange[500],
                                            width: 18,
                                            height: 18,
                                            marginLeft: 5,
                                        }}
                                    />
                                ) : (
                                    <CheckCircleTwoToneIcon
                                        style={{
                                            color: green[500],
                                            width: 18,
                                            height: 18,
                                            marginLeft: 5,
                                        }}
                                    />
                                )}
                            </Box>
                        )}
                    </Grid>
                    {legalLimit !== undefined && (
                        <Grid
                            item
                            xs={12}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            {legalLimit !== null ? (
                                <Typography fontWeight="bold" sx={{ fontSize: 16 }}>
                                    {`${legalLimit === 1
                                        ? t("warning")
                                        : legalLimit === 2
                                            ? t("critic")
                                            : t("Acceptable")
                                        }`}
                                </Typography>
                            ) : (
                                <Typography variant="h6" sx={{ color: "white", opacity: 0.9,marginTop: 1.3 }}>
                                    {t("Data not available")}
                                </Typography>
                            )}
                        </Grid>
                    )}
                </Fragment>
            ) : (
                <Fragment>
                    <Grid
                        item
                        xs={12}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Typography variant="h6" color="white" align="center">
                            {title}
                        </Typography>
                        {legalLimit !== undefined && legalLimit !== null && (
                            <Fragment>
                                {legalLimit ? (
                                    <ErrorTwoToneIcon
                                        style={{
                                            color: red[500],
                                            width: 18,
                                            height: 18,
                                            marginLeft: 5,
                                        }}
                                    />
                                ) : (
                                    <CheckCircleTwoToneIcon
                                        style={{
                                            color: green[500],
                                            width: 18,
                                            height: 18,
                                            marginLeft: 5,
                                        }}
                                    />
                                )}
                            </Fragment>
                        )}

                        {status !== undefined && status !== null && (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                {status === "critic" ? (
                                    <ErrorTwoToneIcon
                                        style={{
                                            color: red[500],
                                            width: 18,
                                            height: 18,
                                            marginLeft: 5,
                                        }}
                                    />
                                ) : status === "warning" ? (
                                    <ReportProblemTwoToneIcon
                                        style={{
                                            color: orange[500],
                                            width: 18,
                                            height: 18,
                                            marginLeft: 5,
                                        }}
                                    />
                                ) : (
                                    <CheckCircleTwoToneIcon
                                        style={{
                                            color: green[500],
                                            width: 18,
                                            height: 18,
                                            marginLeft: 5,
                                        }}
                                    />
                                )}
                            </Box>
                        )}
                    </Grid>
                    {legalLimit !== undefined && (
                        <Grid
                            item
                            xs={12}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            {legalLimit !== null ? (
                                <Typography fontWeight="bold" sx={{ fontSize: 16 }}>
                                    {legalLimit
                                        ? isFem
                                            ? t("Passed fem")
                                            : t("Passed")
                                        : isFem
                                            ? t("Not passed fem")
                                            : t("Not passed")}
                                </Typography>
                            ) : (
                                <Typography variant="h6" sx={{ color: "white", opacity: 0.9,marginTop: 1.3 }}>
                                    {t("Data not available")}
                                </Typography>
                            )}
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        {status === null ?
                            <Typography align="center" variant="h6" sx={{ color: "white", opacity: 0.9, marginTop: 1.3 }}>
                                {t("Data not available")}
                            </Typography> :
                            <Typography
                                color="white"
                                align="center"
                                variant="h6"
                                sx={{ whiteSpace: "nowrap", fontSize: 13 }}
                            >
                                {label}
                            </Typography>}
                        {subLabel !== null && subLabel !== undefined && (
                            <Typography
                                color="white"
                                align="center"
                                variant="h6"
                                sx={{ fontSize: 13, lineHeight: 0.5 }}
                            >
                                {subLabel}
                            </Typography>
                        )}
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        {omsLimit && (
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{ whiteSpace: "nowrap" }}
                            >
                                <Typography sx={{ fontSize: 10 }} pt={0.5} pb={0.5}>
                                    {`${t("OMS threshold")}:  ${omsLimit ? t("Passed fem") : t("Not passed fem")
                                        }`}
                                </Typography>
                                {omsLimit ? (
                                    <ErrorTwoToneIcon
                                        style={{
                                            color: red[500],
                                            width: 15,
                                            height: 15,
                                            marginLeft: 5,
                                        }}
                                    />
                                ) : (
                                    <CheckCircleTwoToneIcon
                                        style={{
                                            color: green[500],
                                            width: 15,
                                            height: 15,
                                            marginLeft: 5,
                                        }}
                                    />
                                )}
                            </Box>
                        )}
                    </Grid>
                </Fragment>
            )}
        </Grid>
    );
};

export default LegaliLimitComponent;
